import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <>
            <footer className="blackBg py-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 footerAddressHldr">
                            <div className="footerAddress">
                                <h3>JB Emporium India Pvt Ltd</h3>
                                <p className="mb-3 d-flex"><i className="fa fa-map-marker me-2"></i> Plot No 1516/78, Ward-31, Daulatabad Industrial Area,<br /> Gurgaon 122006, Haryana India</p>
                                <p><a href="tel:+918800994444"><i className="fa fa-phone me-1"></i> +91 880 099 4444</a> <a href="mailto:query@jbglass.in"><i className="fa fa-envelope me-1"></i> query@jbglass.in</a></p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="footerLogo">
                                <img src="/assets/images/logo.webp" alt="/assets/images/logo.webp" />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <section className="copyRightWrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            &copy; {new Date().getFullYear()} JB Glass. All rights reserved.
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6 policyHldr">
                            {/* <a href="/privacy-policy">Privacy Policy</a> <a href="/terms-and-conditions">Terms Of Use</a> */}
                            <Link to="/privacy-policy">Privacy Policy</Link><Link to="/terms-and-conditions">Terms Of Use</Link>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Footer